import { point } from '@turf/helpers';
import { Location } from '../@types';

export const pointFromLocation = (location: Location) =>
  point([location.longitude, location.latitude]);
